import { isFunction } from 'lodash-es';
export default function scrollDirective($timeout) {
	'ngInject';

	return {
		restrict: 'A',
		scope: {
			callbackFunction: '&scrollThen'
		},
		link: function(scope, element, attrs) {
			if (attrs.scrollIf === 'true') {
				$timeout(() => {
					const parent = $(document.getElementById(attrs.containerId));
					parent.stop().animate(
						{
							scrollTop: element.offset().top - parent.offset().top
						},
						1000
					);
					element.addClass('removehighlighted');
					if (isFunction(scope.callbackFunction)) {
						scope.callbackFunction();
					}
				}, 500);
			}
		}
	};
}
